import React from 'react';
import { FormikContextType } from 'formik';
import { useTranslation } from 'react-i18next';
import FormikCheckboxGroupAccordion from '../../../components/formikComponents/FormikCheckboxGroupAccordion';
import { STAFF_ROLES_CACHE_KEY } from '../../../constants';

const stockOptions = [
  { field: 'stockOptsStockSend' },
  { field: 'stockOptsStockReceive' },
  { field: 'stockOptsStockTake' },
  { field: 'stockOptsUnrestrictedStockTake' },
];

const AdminTillAccessForm = ({
  formik,
  objectId,
}: {
  formik: FormikContextType<unknown>;
  objectId: string;
}) => {
  const { t } = useTranslation();

  return (
    <FormikCheckboxGroupAccordion
      formik={formik}
      formName={STAFF_ROLES_CACHE_KEY}
      objectId={objectId}
      field="stockOptions"
      label={t('screens.staffRoles.stockOptions')}
      checkboxList={stockOptions.map((option) => ({
        field: option.field,
        label: t(`screens.staffRoles.${option.field}`),
      }))}
    />
  );
};

export default AdminTillAccessForm;
